<payee-popup
  [title]="dialogData?.transition_label"
  [onCancel]="onCancel"
>
  <ng-template #payeePopupTitleTemplate>
    <h1 class="title">{{ dialogData?.transition_label }}</h1>
  </ng-template>

  <div class="dialog-content">
    @if (dialogData === undefined) {
      <div class="dialog-data-loading">
        <mat-progress-spinner
          mode="indeterminate"
          diameter="48"
        ></mat-progress-spinner>
      </div>
    }

    @if (dialogData !== undefined) {
      <form [formGroup]="form">
        <mat-checkbox
          formControlName="link_pro_forma"
          color="primary"
          class="link-pro-forma-checkbox"
        >
          {{ "WORKFLOW_DIALOGS.BOOK_BAILIFF_FEE_PAID_PRO_FORMA.LINK_CHECKBOX" | translate }}
        </mat-checkbox>
        @if (link_pro_forma.value) {
          <div class="pro-forma-row">
            <payee-form-field
              width="short"
              height="tall"
            >
              <payee-dropdown
                width="short"
                height="tall"
                [options]="dialogData.pro_forma_invoice_numbers"
                [selected]="pro_forma.value"
                (selectedChange)="pro_forma.patchValue($event)"
              ></payee-dropdown>
            </payee-form-field>
            <payee-form-field
              width="shorter"
              height="tall"
            >
              <input
                payee-input
                type="text"
                formControlName="pro_forma"
                autocomplete="off"
                [attr.placeholder]="'WORKFLOW_DIALOGS.BOOK_BAILIFF_FEE_PAID_PRO_FORMA.MANUAL_PLACEHOLDER' | translate"
              />
            </payee-form-field>
            <button
              type="button"
              payee-icon-button
              color="white"
              [disabled]="loading || dialogData === undefined"
              (click)="clearProForma()"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          </div>
        }
      </form>
    }
  </div>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="loading || dialogData === undefined"
      [loading]="loading"
      (click)="onSubmit()"
    >
      {{ "WORKFLOW_DIALOGS.BOOK_BAILIFF_FEE_PAID_PRO_FORMA.SUBMIT" | translate }}
    </button>
  </ng-template>
</payee-popup>
